/**
 * @file index.js
 * @author Daniel Aguirre
 * @description Initialize About View .
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';

// View
import View from './aboutView';

export const mapStateToPropsAboutView = mapStateToProps;
export const mapDispatchToPropsAboutView = mapDispatchToProps;

export default connect(
  mapStateToPropsAboutView,
  mapDispatchToPropsAboutView
)(View);
